import { DownOutlined } from '@ant-design/icons'
import { Typography, Flex } from 'antd'
import { CSSProperties, useState } from 'react'

type DescriptionCellProps = {
  text: string
  style?: CSSProperties
}

export const DescriptionCell = ({ text, style }: DescriptionCellProps) => {
  const [expanded, setExpanded] = useState(false)
  const [isEllipsis, setIsEllipsis] = useState(false)
  const { Paragraph } = Typography

  return (
    <Flex align="center" gap={8}>
      <Paragraph
        style={{ margin: 0, flex: 1, ...style }}
        ellipsis={{
          rows: 3,
          expandable: 'collapsible',
          expanded,
          symbol: () => null,
          onEllipsis: setIsEllipsis,
        }}
      >
        {text}
      </Paragraph>

      {isEllipsis && (
        <DownOutlined
          style={{
            cursor: 'pointer',
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
            color: 'var(--color-primary)',
          }}
          onClick={() => setExpanded((prev) => !prev)}
        />
      )}
    </Flex>
  )
}
